import "./controller.js"; // This will execute the code in controller.js
